module.exports = __webpack_public_path__ + "static/media/tavi_brand_banner.37cd556e.jpg";